export default __webpack_public_path__ + "static/media/user-icon.a8bc2449.svg";